import {TextInput as TextInputComponent} from "./TextInput";

export const TextInput = Object.assign(TextInputComponent, {})